interface IProps {
    message: string | Record<string, any> | undefined;
}

const FormFieldError: React.FC<IProps> = ({ message }) => {
    return <div className="invalid-feedback d-block">{(message as string) || ""}</div>;
};
export default FormFieldError;
